import { AxiosResponse } from "axios";
import { Repository } from "@react3l/react3l/core";
import { kebabCase, url } from "@react3l/react3l/helpers";
import { httpConfig } from "config/http";
import { BASE_API_URL } from "config/consts";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import nameof from "ts-nameof.macro";

import { API_ISSUE_PREFIX } from "config/api-consts";
import { Issue, IssueFilter, IssueType } from "models/Issue";

export class IssueRepository extends Repository {
  constructor() {
    super(httpConfig);
    this.baseURL = url(BASE_API_URL, API_ISSUE_PREFIX);
  }

  public count = (issueFilter?: IssueFilter): Observable<number> => {
    return this.httpObservable
      .post<number>(kebabCase(nameof(this.count)), issueFilter)
      .pipe(map((response: AxiosResponse<number>) => response.data));
  };

  public list = (issueFilter?: IssueFilter): Observable<Issue[]> => {
    return this.httpObservable
      .post<Issue[]>(kebabCase(nameof(this.list)), issueFilter)
      .pipe(map((response: AxiosResponse<Issue[]>) => response.data));
  };

  public get = (id: number | string): Observable<Issue> => {
    return this.httpObservable
      .post<Issue>(kebabCase(nameof(this.get)), { id })
      .pipe(map((response: AxiosResponse<Issue>) => response.data));
  };

  public singleListIssueType = (): Observable<IssueType[]> => {
    return this.httpObservable
      .post<IssueType[]>(
        kebabCase(nameof(this.singleListIssueType)),
        { statusId: { equal: 1 } }
      )
      .pipe(map((response: AxiosResponse<IssueType[]>) => response.data));
  };

  public listByEndUser = (endUserId: string): Observable<Issue[]> => {
    const filter: IssueFilter = {
      endUserId: { equal: endUserId },
      skip: 0,
      take: 100,
    } as any;
    return this.httpObservable
      .post<Issue[]>(kebabCase(nameof(this.list)), filter)
      .pipe(map((response: AxiosResponse<Issue[]>) => response.data));
  };
}

export const issueRepository = new IssueRepository();
